
















import { Component, Vue, Prop } from "vue-property-decorator";
import Crumbs from "@/components/Crumbs/index.vue";
import CContentTop from "@/components/CContentTop.vue";

@Component({
  name: "CList",
  components: {
    Crumbs,
    CContentTop
  }
})
export default class CList extends Vue {
  @Prop({
    default: () => []
  })
  bread!: Common.CBread[];

  @Prop({
    default: true
  })
  contentTop!: boolean;
}
